var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_GET_DOMAIN_BLOCKLIST } from ".";
// each client has its own blocklist
// one account can manage one domain, in the future several
// will be many to many relationship
// blocklist related to the domain
export const getDomainBlocklist = (domain, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_GET_DOMAIN_BLOCKLIST + domain);
        return response.data;
    }
    catch (err) {
        return [];
    }
});
export const getDomainBlocklistItem = (domain, address, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_GET_DOMAIN_BLOCKLIST + `${domain}/${address}`);
        return response.data;
    }
    catch (err) {
        return null;
    }
});
export const deleteDomainBlocklistItem = (domain, address, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.delete(API_GET_DOMAIN_BLOCKLIST + `${domain}/${address}`);
        return response.data;
    }
    catch (err) {
        return null;
    }
});
export const updateDomainBlocklistItem = (domain, address, data, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.put(API_GET_DOMAIN_BLOCKLIST + `${domain}/${address}`, data);
        return response.data;
    }
    catch (err) {
        return null;
    }
});
export const addDomainBlocklistItem = (domain, data, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.post(API_GET_DOMAIN_BLOCKLIST + domain, data);
        return response.data;
    }
    catch (err) {
        return [];
    }
});
//# sourceMappingURL=blocklist.js.map